class Sidebar {
  public sidebar: HTMLElement | null;
  public sidebarCloseButton: HTMLAnchorElement | null;

  cache() {
    this.sidebar = document.querySelector('.js-sidebar');
    this.sidebarCloseButton = document.querySelector('.js-sidebar-close');
  }

  bindings() {
    if (this.sidebar) {
      window.addEventListener('scroll', () => {
        if (window.innerWidth > 768 && window.scrollY > 500) {
          if (!this.sidebar?.classList.contains('is-hidden')) {
            this.sidebar?.classList.add('is-visible');
          }
        }
      });
    }

    if (this.sidebarCloseButton) {
      this.sidebarCloseButton.addEventListener('click', (e: Event) => {
        e.preventDefault();

        if (this.sidebar) {
          this.sidebar.classList.remove('is-visible');
          this.sidebar.classList.add('is-hidden');
        }
      });
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Sidebar;
